import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { SdfCardLabels } from 'src/app/app.models';
import { LocationResultServices } from 'src/app/models/location.model';

@Component({
    selector: 'app-location-services',
    templateUrl: './location-services.component.html',
    styleUrls: ['./location-services.component.scss'],
    standalone: false
})
export class LocationServicesComponent implements OnInit {
  private _locationServices: any;
  supportedServices: string[] = ['sendMoney', 'receiveMoney'];
  sdfCardLabels: SdfCardLabels;
  @Input() public set locationServices(locationServices: any) {
    this._locationServices = locationServices;
  }

  get locationServices() {
    return this._locationServices;
  }
  storeServices: string[] = [];
  locationLabels: any;
  public _labels!: any;
  @Input() public set labels(labels: any) {
    this._labels = labels;
    this.sdfCardLabels = labels.stellar.sdfCardLabels;
    this.locationLabels = labels.stellar.location;
  }

  public get labels() {
    return this._labels;
  }
  constructor() { }

  ngOnInit(): void {
    this.getLotionServices(this.locationServices, this.locationLabels);
  }

  getLotionServices(locationServices: any, locationLabels: any) {
    if (!locationServices || !locationLabels) return null;
    const storeServices: string[] = [];
    for (const key in locationServices) {
      if (
        locationServices.hasOwnProperty(key) &&
        locationLabels.hasOwnProperty(key)
      ) {
        if (
          this.locationServices[key] === true &&
          this.supportedServices.includes(key)
        ) {
          storeServices.push(locationLabels[key]);
        }
      }
    }
    this.storeServices = storeServices;
    return this.storeServices;
  }
}
